import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import axios from "axios";
import "./List.css";

function Pricelist() {
  const [priceList, setPriceList] = useState([]);

  // Fetch documents on component mount
  useEffect(() => {
    const fetchDocuments = async () => {
      try {
        const response = await axios.get(
          "https://pricelist.rukmanimfg.com/api/file/getAlldocuments" // Ensure the URL matches the backend route
        );
        if (response.data.success) {
          setPriceList(response.data.documents);
        }
      } catch (error) {
        console.error("Error fetching documents:", error);
      }
    };

    fetchDocuments();
  }, []);

  // Handle delete document
  const handleDelete = async (documentName) => {
    try {
      const response = await axios.delete(
        "https://pricelist.rukmanimfg.com/api/file/deletedocument", // Route for deleting document
        { data: { document_name: documentName } } // Sending document_name in the body
      );
      if (response.data.success) {
        // Update state after delete
        setPriceList(
          priceList.filter((item) => item.document_name !== documentName)
        );
      }
    } catch (error) {
      console.error("Error deleting document:", error);
    }
  };

  return (
    <div>
      <div className="container-fluid" style={{ backgroundColor: "#4d8eff" }}>
        <nav className="navbar navbar-expand-lg custom_nav-container">
          <a className="navbar-brand" href="index.html">
            <img src="images/logo.png" alt />
            <span>RMR</span>
          </a>
        </nav>
      </div>
      <section className="price_list_section layout_padding">
        <div className="container">
          <div className="row">
            <div className="col-12">
              <div className="heading_container">
                <h2>Price List</h2>
              </div>

              {/* Add Button */}
              <div className="add-button-container">
                <Link to="/add" className="btn btn-add">
                  + Add
                </Link>
              </div>

              {/* Table */}
              <table className="table">
                <thead>
                  <tr>
                    <th>Name</th>
                    <th>File</th>
                    <th>Actions</th>
                  </tr>
                </thead>
                <tbody>
                  {priceList.map((item) => (
                    <tr key={item._id}>
                      <td>{item.document_name}</td>
                      <td>
                        {/* Clean file name by removing prefix */}
                        {item.document
                          .split("/")
                          .pop()
                          .split("-")
                          .slice(1)
                          .join("-")}
                      </td>
                      <td>
                        <Link
                          to={`https://pricelist.rukmanimfg.com/api/file/view/${item.document}`}
                          target="_blank"
                          rel="noopener noreferrer"
                          className="btn-adds addll"
                        >
                          View
                        </Link>
                      </td>
                      <td>
                        <button
                          onClick={() => handleDelete(item.document_name)}
                          className="btn-addss addlld"
                        >
                          Delete
                        </button>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}

export default Pricelist;
